// extracted by mini-css-extract-plugin
module.exports = {"card":"styles-module--card--3bWbT","title":"styles-module--title--2eGz-"};